// extracted by mini-css-extract-plugin
module.exports = {"header":"_5D246O-u","titles":"_5D3ApVen","title":"_5D31ID0C","subtitle":"_5DZXOZO0","image-container":"_5D2pvqMT","image":"_5D2AfncX"};